export default "__VITE_ASSET__4d87ad0d__"